export default class CourseLinks {
    key?: string | null;
    title: string;
    link: string;
  }